import React, { useState } from "react";
import admin from "../../images/adminSecurity.png";

export default function CreatePasswordForAdmin() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  return (
    <div className="relative flex">
      {/* Left Section */}
      <div className="relative h-screen w-1/2">
        <img
          src={admin}
          alt="Admin Security"
          className="absolute w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#038B47] to-[#00AED9] mix-blend-multiply" />
        <h2 className="absolute left-16 top-[330px] text-white text-[32px] font-bold leading-[39px] max-w-[416px]">
          Redefining Carbon Emission Solutions...
        </h2>
      </div>

      {/* Right Section */}
      <div className="h-screen w-1/2 relative p-12 ml-10">
        <div className="flex flex-col gap-5 mb-10">
          <h2 className="text-[32px] font-bold leading-[39px] text-[#101828] mt-20">
            Sign Up
          </h2>
          <p className="text-[14px] leading-[17px] text-[#667185]">
            Great! Your email is verified. Now set a secure password to complete
            your admin account.
          </p>
        </div>

        {/* Password Field */}
        <div className="flex flex-col gap-2 mb-10">
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Create a password"
              className="w-full h-[40px] border-b border-[#98A2B3] focus:outline-none text-sm text-[#101828] bg-transparent pr-8"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-2 top-1/2 -translate-y-1/2"
            >
              {showPassword ? (
                // 👁 OPEN EYE
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#667185"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              ) : (
                // 👁 CLOSED EYE
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#667185"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.29 20.29 0 0 1 5.06-6.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a20.29 20.29 0 0 1-2.06 3.34M1 1l22 22"></path>
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Confirm Password Field */}
        <div className="flex flex-col gap-2 mb-10">
          <div className="relative w-full">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm your password"
              className="w-full h-[40px] border-b border-[#98A2B3] focus:outline-none text-sm text-[#101828] bg-transparent pr-8"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="absolute right-2 top-1/2 -translate-y-1/2"
            >
              {showConfirmPassword ? (
                // 👁 OPEN EYE
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#667185"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              ) : (
                // 👁 CLOSED EYE
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#667185"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a20.29 20.29 0 0 1 5.06-6.94M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 8 11 8a20.29 20.29 0 0 1-2.06 3.34M1 1l22 22"></path>
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Button */}
        <button className="w-full h-[80px] mt-20 flex items-center justify-center bg-gradient-to-br from-[#038B47] to-[#00AED9] text-white text-[16px] font-semibold rounded-lg">
          Continue
        </button>
      </div>
    </div>
  );
}
